/**
 * SubsectionBlock - one collapsible sub-section of a phase: its header (chevron,
 * name, Ch. chip, signed count), the desktop robot header row, and the ItemRows.
 */
import { GREEN, stripChapter } from './svmModel';
import ItemRow from './ItemRow';

export default function SubsectionBlock({
  zoneKey,
  robots,
  phaseName,
  sub,
  checks,
  stat,
  collapsed,
  onToggle,
  robotFilter,
  narrow,
  onCellClick,
  onMenuClick,
}) {
  const gridTemplate = `minmax(0, 1fr) repeat(${robots.length}, 54px) 24px`;
  const displayName = stripChapter(sub.name);
  const hasRobotItems = (sub.items || []).some((it) => it.scope !== 'cell');
  return (
    <div style={{ marginBottom: 10 }}>
      <button
        type="button"
        onClick={() => onToggle(`${phaseName}|${sub.name}`)}
        style={{
          width: '100%',
          textAlign: 'left',
          background: '#F7F9F7',
          border: '1px solid #E6EDE6',
          borderRadius: 8,
          padding: narrow ? '8px 10px' : '8px 12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: narrow ? 8 : 10,
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <span style={{ fontSize: 10, color: '#888' }}>{collapsed ? '▸' : '▾'}</span>
        <span
          style={{
            fontSize: 12,
            fontWeight: 800,
            color: '#0D0D0D',
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {displayName}
        </span>
        {sub.chapter ? (
          <span
            style={{
              fontSize: 9,
              fontWeight: 800,
              color: GREEN,
              background: '#E8F5E9',
              borderRadius: 20,
              padding: '2px 9px',
              whiteSpace: 'nowrap',
            }}
          >
            Ch. {sub.chapter}
          </span>
        ) : null}
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 700,
            color: stat.s >= stat.t && stat.t > 0 ? GREEN : '#999',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap',
          }}
        >
          {stat.s}/{stat.t} signed
        </span>
      </button>
      {!collapsed && (
        <div style={{ padding: narrow ? '4px 0 0' : '6px 2px 2px' }}>
          {/* No robot header row on narrow - each cell carries its own label. */}
          {hasRobotItems && !narrow && (
            <div style={{ display: 'grid', gridTemplateColumns: gridTemplate, columnGap: 4, padding: '2px 0 4px' }}>
              <span />
              {robots.map((r) => (
                <span
                  key={r}
                  style={{
                    fontSize: 9,
                    fontWeight: 800,
                    color: robotFilter !== 'ALL' && robotFilter !== r ? '#DDD' : '#999',
                    textAlign: 'center',
                    letterSpacing: 0.5,
                  }}
                >
                  {r}
                </span>
              ))}
              <span />
            </div>
          )}
          {(sub.items || []).map((item) => (
            <ItemRow
              key={item.no}
              zoneKey={zoneKey}
              robots={robots}
              item={item}
              checks={checks}
              robotFilter={robotFilter}
              narrow={narrow}
              onCellClick={onCellClick}
              onMenuClick={onMenuClick}
            />
          ))}
        </div>
      )}
    </div>
  );
}
